import { Grid2 as Grid, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import logoWhite from '../../Images/logo-white@2x.png';

const LogoAddress: React.FC = () => {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Grid
            container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMdUp ? 'flex-start' : 'center'
            }}
        >
            <Grid>
                <img
                    src={logoWhite}
                    alt="NCQA White Logo"
                    style={{
                        height: '100px',
                        marginBottom: theme.spacing(1)
                    }}
                />
            </Grid>
            <Grid>
                <Box
                    component="address"
                    sx={{
                        color: 'white',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: 1.57,
                        opacity: 0.5,
                        fontWeight: 'lighter',
                        paddingLeft: '0',
                        marginLeft: theme.spacing(4),
                        marginTop: theme.spacing(1),
                        '& a': {
                            color: 'white',
                            textDecoration: 'none'
                        }
                    }}
                >
                    1100 13th St., NW, Third Floor <br />
                    Washington, D.C. 20005 <br />
                    <a href="tel:+12029553500">202.955.3500</a>
                </Box>
            </Grid>
        </Grid>
    );
};

export default LogoAddress;
